export default {
  "productPhotos": { "unsavedTitle":"Save your changes?","unsavedBody":"Save or discard the product photo setting before leaving this template.","save":"Save","discard":"Discard","cancel":"Cancel","saveFailed":"The changes could not be saved. Your pending setting has been kept. Please try again.","label": "Show product photos", "help": "Uses the photos already saved against products. Save the layout to keep this setting." },
  "copy0": "Recipe usage can be entered in units compatible with",
  "copy1": "No matches found.",
  "copy2": "Name",
  "copy3": "Main Bar",
  "copy4": "Outlet Type",
  "copy5": "Select outlet type",
  "copy6": "Menus available at this outlet",
  "copy7": "Select every menu this outlet can serve, then choose one default menu.",
  "copy8": "Public ordering enabled",
  "copy9": "Service Mode",
  "copy10": "Select service mode",
  "copy11": "Quick Service",
  "copy12": "Table Service",
  "copy13": "Table Selection",
  "copy14": "Select requirement",
  "copy15": "Required",
  "copy16": "Optional",
  "copy17": "Dining Areas",
  "copy18": "Create dining areas first to assign them here.",
  "copy19": "Inventory Location",
  "copy20": "Optional location",
  "copy21": "No location",
  "copy22": "Active outlet",
  "copy23": "Enable or disable this outlet.",
  "copy24": "Cancel",
  "copy25": "Save outlet",
  "copy26": "Dining Room Dinner",
  "copy27": "Outlet assignment",
  "copy28": "Assign this menu to outlets from the Outlet settings.",
  "copy29": "Active menu",
  "copy30": "Hide or publish this menu.",
  "copy31": "Enable for room service",
  "copy32": "Publish this menu to in-room screens.",
  "copy33": "Surcharge (%)",
  "copy34": "Delivery fee",
  "copy35": "Surcharge applies to each item on this menu. Delivery fee applies once per order in a later phase.",
  "copy36": "Menu items",
  "copy37": "Update the line items that appear on this menu.",
  "copy38": "Button Label",
  "copy39": "Item Name",
  "copy40": "Pack Size",
  "copy41": "Cost",
  "copy42": "Sell Price",
  "copy43": "Actions",
  "copy44": "No menu items yet.",
  "copy45": "Single",
  "copy46": "0.00",
  "copy47": "Duplicate menu",
  "copy48": "Save menu",
  "copy49": "Remove menu item?",
  "copy50": "Remove",
  "copy51": "from this menu.",
  "copy52": "Select an outlet to generate a launch link.",
  "copy53": "Launch Link",
  "copy54": "Secure outlet URL + rotating OTP.",
  "copy55": "Outlet URL",
  "copy56": "One-time passcode",
  "copy57": "Expires in",
  "copy58": "QR pending",
  "copy59": "Scan to open terminal",
  "copy60": "Regenerate terminal secret",
  "copy61": "POS Staff Access",
  "copy62": "Assign club staff to cashier PIN login. PIN hashes stay server-side and old PINs are never shown.",
  "copy63": "Search assigned staff…",
  "copy64": "Add staff",
  "copy65": "Assigned",
  "copy66": "PIN set",
  "copy67": "Last login:",
  "copy68": "Permission level",
  "copy69": "Standard",
  "copy70": "Enhanced",
  "copy71": "Generate/reset PIN",
  "copy72": "Remove from ePOS",
  "copy73": "Outlet access",
  "copy74": "All outlets",
  "copy75": "This staff member can log in at every POS outlet.",
  "copy76": "No staff are assigned to ePOS.",
  "copy77": "Add ePOS staff",
  "copy78": "Select one or more active club staff. Assignment does not change their core Staff account.",
  "copy79": "Search eligible staff…",
  "copy80": "Assign selected",
  "copy81": "New POS PIN",
  "copy82": "This PIN is only shown once. It cannot be recovered later.",
  "copy83": "Copy PIN",
  "copy84": "Done",
  "copy85": "does not have the ePOS Management module enabled.",
  "copy86": "Setup Wizard",
  "copy87": "Create outlet",
  "copy88": "Create menu",
  "copy89": "Active outlets",
  "copy90": "Live outlets currently accepting orders.",
  "copy91": "Active menus",
  "copy92": "Menus assigned to outlets and enabled.",
  "copy93": "Buttons configured",
  "copy94": "Buttons configured on the selected menu.",
  "copy95": "Outlets at a glance",
  "copy96": "Quickly jump into launch links and status.",
  "copy97": "No outlets yet",
  "copy98": "Create your first outlet to start building menus.",
  "copy99": "Launch link",
  "copy100": "Outlets",
  "copy101": "Refresh",
  "copy102": "Manage serving locations and defaults.",
  "copy103": "Set up a bar, dining room, or pro shop outlet.",
  "copy104": "Updated",
  "copy105": "Edit outlet",
  "copy106": "Outlet details",
  "copy107": "Default menu and inventory mappings.",
  "copy108": "Default menu",
  "copy109": "Outlet",
  "copy110": "Inventory location",
  "copy111": "Stock",
  "copy112": "Menus",
  "copy113": "Assign menus to outlets and keep them current.",
  "copy114": "No menus yet",
  "copy115": "Create your first menu and start adding buttons.",
  "copy116": "Menu selector",
  "copy117": "Select a menu",
  "copy118": "outlets)",
  "copy119": "Edit menu",
  "copy120": "Duplicate",
  "copy121": "Menu builder",
  "copy122": "Design the button grid for the selected menu.",
  "copy123": "item",
  "copy124": "configured.",
  "copy125": "Choose a menu to start configuring buttons.",
  "copy126": "All active ePOS products",
  "copy127": "Browse, filter, tick multiple products, then add them together.",
  "copy128": "Add Selected",
  "copy129": "Quick search products...",
  "copy130": "Category",
  "copy131": "Searching items...",
  "copy132": "Added",
  "copy133": "Buttons",
  "copy134": "Menu buttons could not load.",
  "copy135": "This menu has no buttons",
  "copy136": "Search active ePOS products above, then tap Add to build your POS grid.",
  "copy137": "Add items",
  "copy138": "Item record missing from inventory.",
  "copy139": "Item inactive or not sellable.",
  "copy140": "ePOS Products",
  "copy141": "Products are what members and guests buy at the till; recipes handle stock consumption.",
  "copy142": "Create Product",
  "copy143": "Products are temporarily unavailable.",
  "copy144": "Product name*",
  "copy145": "Product name",
  "copy146": "e.g. Carling Pint",
  "copy147": "Draught Beer",
  "copy148": "Sell price shown to member/guest",
  "copy149": "Sell price",
  "copy150": "6.50",
  "copy151": "Sell price includes VAT?",
  "copy152": "Yes",
  "copy153": "No",
  "copy154": "Tax code",
  "copy155": "Linked stock item (recipe convenience only)",
  "copy156": "Select stock item",
  "copy157": "No linked recipe item",
  "copy158": "Product image",
  "copy159": "Product image upload",
  "copy160": "Send to KDS / requires preparation",
  "copy161": "Default is off for safety. Products marked as requiring KDS use routing rules.",
  "copy162": "Prep category",
  "copy163": "Edit in Inventory",
  "copy164": "Edit",
  "copy165": "Deactivate",
  "copy166": "Create recipe",
  "copy167": "No ePOS products yet",
  "copy168": "Create Carling Pint, Bottle of Coke, Cheeseburger, and other till buttons here.",
  "copy169": "Recipes",
  "copy170": "Recipes define which inventory items are consumed when a POS product is sold.",
  "copy171": "Recipes are temporarily unavailable.",
  "copy172": "Choose a product and define the stock consumed per sale.",
  "copy173": "Cancel edit",
  "copy174": "Product*",
  "copy175": "Select ePOS product",
  "copy176": "Search products by name, SKU, item code, category, subcategory, or unit...",
  "copy177": "Ingredients / inventory consumed",
  "copy178": "Add ingredient",
  "copy179": "Stock-tracked item",
  "copy180": "Search stock items by name, SKU, item code, category, subcategory, or unit...",
  "copy181": "Quantity consumed",
  "copy182": "568",
  "copy183": "Edit lines",
  "copy184": "No recipes yet",
  "copy185": "Use the setup wizard or create a product, then define what stock it consumes.",
  "copy186": "ePOS Transactions",
  "copy187": "Operational orders/checks/tabs and completed sale/payment records with inventory traceability.",
  "copy188": "Transaction date from",
  "copy189": "Transaction date to",
  "copy190": "Transaction outlet",
  "copy191": "Transaction status",
  "copy192": "Status",
  "copy193": "Default status",
  "copy194": "Active orders",
  "copy195": "Open",
  "copy196": "Pending payment",
  "copy197": "Sent to kitchen",
  "copy198": "Unpaid",
  "copy199": "Paid / completed",
  "copy200": "Voided",
  "copy201": "Refunded",
  "copy202": "Cancelled",
  "copy203": "Transaction search",
  "copy204": "Search sale, table, product",
  "copy205": "Reset filters",
  "copy206": "Orders",
  "copy207": "Sales",
  "copy208": "Loading transactions…",
  "copy209": "View detail",
  "copy210": "No operational orders found for the selected filters.",
  "copy211": "No completed sales found for the selected filters.",
  "copy212": "Loading detail…",
  "copy213": "Number",
  "copy214": "Table",
  "copy215": "Staff / cashier",
  "copy216": "Total",
  "copy217": "Subtotal",
  "copy218": "Tax",
  "copy219": "Line items",
  "copy220": "Qty",
  "copy221": "No line items recorded.",
  "copy222": "Payments",
  "copy223": "No payments recorded.",
  "copy224": "Receivable summary",
  "copy225": "Original",
  "copy226": "• Outstanding",
  "copy227": "Payment allocation summary",
  "copy228": "Member account impact",
  "copy229": "Tax breakdown",
  "copy230": "GL summary",
  "copy231": "Debits",
  "copy232": "Credits",
  "copy233": "Dr",
  "copy234": "• Cr",
  "copy235": "Inventory consumption summary",
  "copy236": "Quantity",
  "copy237": "• Recipe quantity",
  "copy238": "Edit ePOS product",
  "copy239": "Update the till product details shown to members and guests.",
  "copy240": "Edit product name",
  "copy241": "Edit sell price",
  "copy242": "Linked stock item",
  "copy243": "No direct stock link",
  "copy244": "Product preview",
  "copy245": "No image",
  "copy246": "Edit product image upload",
  "copy247": "Products marked as requiring KDS will be sent to the first matching active route.",
  "copy248": "Active / sellable",
  "copy249": "Save product",
  "copy250": "Deactivate product?",
  "copy251": "This removes the product from active ePOS selection but keeps its history.",
  "copy252": "Inventory / ePOS Setup Wizard",
  "copy253": "Stock item = what the club buys/stores. ePOS product = what the member/guest buys. Recipe = how much stock is consumed per sale, e.g. stock a 30 L keg, sell a pint, and consume 568 ml from keg stock.",
  "copy254": "What are you setting up?",
  "copy255": "The wizard is deterministic: it uses only the fields below. AI-assisted suggestions are available later behind the disabled feature flag.",
  "copy256": "Stock item name*",
  "copy257": "e.g. 30 L beer keg",
  "copy258": "SKU / barcode / item code",
  "copy259": "Beer",
  "copy260": "Purchase unit",
  "copy261": "Purchase quantity / size",
  "copy262": "30",
  "copy263": "Purchase size unit",
  "copy264": "Supplier cost price",
  "copy265": "100.00",
  "copy266": "Purchasing tax code",
  "copy267": "Optional tax code id",
  "copy268": "ePOS product name*",
  "copy269": "e.g. Pint product",
  "copy270": "Consumes one stock unit per sale?",
  "copy271": "Yes, consume 1 each",
  "copy272": "No, I will define recipe lines",
  "copy273": "Serving size consumed",
  "copy274": "Serving unit",
  "copy275": "Existing ePOS product*",
  "copy276": "Select product",
  "copy277": "Recipe ingredients",
  "copy278": "1",
  "copy279": "Create setup",
  "copy280": "Current Sale",
  "copy281": "Assign table",
  "copy282": "Clear",
  "copy283": "Remove selected item",
  "copy284": "Items",
  "copy285": "VAT included",
  "copy286": "Pay",
  "copy287": "POS terminal",
  "copy288": "Clear current sale?",
  "copy289": "Cancel clear sale",
  "copy290": "This will remove the current table assignment and clear the sale from this terminal.",
  "copy291": "Send to kitchen",
  "copy292": "Close",
  "copy293": "Prep notes",
  "copy294": "Add prep notes (optional)",
  "copy295": "Fire now",
  "copy296": "Manual barcode entry",
  "copy297": "USB/Bluetooth scanners and manual entry supported.",
  "copy298": "Close barcode entry",
  "copy299": "Scan or type barcode",
  "copy300": "Refocus scanner",
  "copy301": "Last scanned:",
  "copy302": "· Added",
  "copy303": "Lock",
  "copy304": "Staff Login",
  "copy305": "Staff Login — Enter your 4-digit code for access",
  "copy306": "Staff PIN",
  "copy307": "Delete",
  "copy308": "Staff:",
  "copy309": "Open terminal options",
  "copy310": "Terminal options",
  "copy311": "Close terminal options",
  "copy312": "Choose whether to log out the current staff member or lock this terminal.",
  "copy313": "Log Out",
  "copy314": "Lock Screen",
  "copy315": "Menu",
  "copy316": "Tables",
  "copy317": "Open manual barcode entry",
  "copy318": "Scan / Barcode",
  "copy319": "Select a table to begin.",
  "copy320": "Table view mode",
  "copy321": "Tiles",
  "copy322": "Floor plan",
  "copy323": "No dining areas assigned to this outlet.",
  "copy324": "No tables in this area yet.",
  "copy325": "Occupied",
  "copy326": "Payment",
  "copy327": "Total Due",
  "copy328": "Card",
  "copy329": "Pay (Card Present)",
  "copy330": "Cash",
  "copy331": "Instant settle",
  "copy332": "Member",
  "copy333": "Simulated Reader (test mode)",
  "copy334": "Preparing new sale…",
  "copy335": "v",
  "copy336": "· Updated",
  "copy337": "Assigned:",
  "copy338": "Publish",
  "copy339": "Archive",
  "copy340": "Edit template",
  "copy341": "Manage template details, lifecycle state and outlet assignment safety.",
  "copy342": "Template name",
  "copy343": "Description",
  "copy344": "Default terminal size",
  "copy345": "Assigned outlets",
  "copy346": "Deleting a template deactivates these assignments before removal so outlets safely fall back to their next available template or legacy menu.",
  "copy347": "Unpublish to draft",
  "copy348": "Restore to draft",
  "copy349": "Delete template",
  "copy350": "Save",
  "copy351": "Delete POS template",
  "copy352": "Confirm removal of this POS Screen Designer template.",
  "copy353": "Template:",
  "copy354": "Any active outlet assignments for this template will be deactivated before the template is deleted.",
  "copy355": "Child template links and copied-template lineage references will be detached so related templates remain available.",
  "copy356": "Folder ·",
  "copy357": "items",
  "copy358": "W+",
  "copy359": "W-",
  "copy360": "H+",
  "copy361": "H-",
  "copy362": "Privana Assist",
  "copy363": "Privana Assist POS layout instruction",
  "copy364": "Describe the POS screen you want to build or improve…",
  "copy365": "Designing…",
  "copy366": "Submit",
  "copy367": "Privana is designing your screen…",
  "copy368": "Reviewing and refining your products, pages and touch layout.",
  "copy369": "Proposal ready for review",
  "copy370": "Review proposal",
  "copy371": "Regenerate",
  "copy372": "Change products",
  "copy373": "Cancel pending proposal",
  "copy374": "Cancel proposal",
  "copy375": "Choose products for this POS screen",
  "copy376": "Select up to 100 products for Privana Assist to arrange.",
  "copy377": "Search products",
  "copy378": "Search by product name, SKU or barcode",
  "copy379": "product",
  "copy380": "shown",
  "copy381": "Select visible",
  "copy382": "Clear selection",
  "copy383": "No eligible ePOS products are available.",
  "copy384": "No products match your search.",
  "copy385": "of 100 selected",
  "copy386": "This confirmation uses your template and selected products. Generation has not started yet.",
  "copy387": "I'll optimise for:",
  "copy388": "Design objective",
  "copy389": "(optional)",
  "copy390": "Back",
  "copy391": "Change retail type",
  "copy392": "Why Privana recommended this layout",
  "copy393": "Layout confidence",
  "copy394": "Recommendations",
  "copy395": "Mode:",
  "copy396": "Device:",
  "copy397": "Removed",
  "copy398": "pages,",
  "copy399": "nodes and",
  "copy400": "buttons.",
  "copy401": "Why Privana designed it this way",
  "copy402": "POS Screen Designer tools",
  "copy403": "Expand designer sidebar",
  "copy404": "Expand sidebar",
  "copy405": "POS Screen Designer",
  "copy406": "Build touch-first screens from your live products and menus.",
  "copy407": "Collapse designer sidebar",
  "copy408": "Collapse sidebar",
  "copy409": "Designer tools",
  "copy410": "Create template",
  "copy411": "Generate starter from menus",
  "copy412": "Outlet assignments override the all-outlets fallback.",
  "copy413": "Assign to all outlets",
  "copy414": "Assign",
  "copy415": "Pages",
  "copy416": "Up",
  "copy417": "Down",
  "copy418": "Linked from",
  "copy419": "folder button",
  "copy420": "; deleting makes them fall back to child-node auto layout.",
  "copy421": "Products",
  "copy422": "Folders",
  "copy423": "Folder button",
  "copy424": "Coming soon",
  "copy425": "Dynamic content",
  "copy426": "Properties",
  "copy427": "Theme, layout and selected button/node settings.",
  "copy428": "Theme background",
  "copy429": "Selected button",
  "copy430": "Button colour",
  "copy431": "x",
  "copy432": ", y",
  "copy433": ", w",
  "copy434": ", h",
  "copy435": "Nothing selected",
  "copy436": "Select a canvas button or navigation node to edit its properties.",
  "copy437": "Selected node",
  "copy438": "Designed page",
  "copy439": "No designed page",
  "copy440": "Action key",
  "copy441": "Dynamic source key",
  "copy442": "Child folder",
  "copy443": "Child product",
  "copy444": "Delete node",
  "copy445": "Navigation tree",
  "copy446": "POS canvas workspace",
  "copy447": "Editing actions",
  "copy448": "Page",
  "copy449": "Save layout",
  "copy450": "visible grid ·",
  "copy451": "scrollable rows",
  "copy452": "Start building this page",
  "copy453": "Drag an item from the Library onto the canvas.",
  "copy454": "Canvas status",
  "copy455": "columns",
  "copy456": "visible rows",
  "copy457": "logical rows",
  "copy458": "Privana",
  "copy459": "Member (optional)",
  "copy460": "Attach a member for attribution & receipts.",
  "copy461": "Applied",
  "copy462": "Member number",
  "copy463": "Loading floor plan…",
  "copy464": "Center selected table",
  "copy465": "Center selected",
  "copy466": "Zoom out floor plan",
  "copy467": "Fit floor plan",
  "copy468": "Fit",
  "copy469": "Zoom in floor plan",
  "copy470": "Floor plan table status legend",
  "copy471": "Available",
  "copy472": "Selected",
  "copy473": "Unlinked",
  "copy474": "Zone",
  "copy475": "Close zone summary",
  "copy476": "Seats",
  "copy477": "No linked tables in this zone",
  "copy478": "This floor plan has no visual tables linked yet. Tiles are still available.",
  "extra0": "Bar",
  "extra1": "Dining",
  "extra2": "Pro Shop",
  "extra3": "Halfway House",
  "extra4": "This item",
  "extra5": " or ",
  "extra6": "Yes",
  "extra7": "No",
  "extra8": "QR Self Service",
  "extra9": "Payment",
  "extra10": "Stock only",
  "extra11": "Simple product bought and sold as-is",
  "extra12": "Draft beer / measured drink",
  "extra13": "Recipe / food item",
  "extra14": "Choose a setup mode.",
  "extra15": "Inventory item name is required.",
  "extra16": "Select an existing ePOS product.",
  "extra17": "Product name is required.",
  "extra18": "Sell price must be zero or higher.",
  "extra19": "Consumption quantity must be greater than zero.",
  "extra20": "Add at least one recipe ingredient or switch to one-to-one consumption.",
  "extra21": "Add at least one recipe ingredient.",
  "extra22": "Select option",
  "extra26": "Edit Outlet",
  "extra27": "Create Outlet",
  "extra28": "Untitled menu",
  "extra29": "Active",
  "extra30": "Inactive",
  "extra31": "Inventory location",
  "extra32": "Unable to load menu items",
  "extra33": "Invalid surcharge",
  "extra34": "Surcharge must be between 0 and 100.",
  "extra35": "Invalid delivery fee",
  "extra36": "Delivery fee must be 0 or higher.",
  "extra37": "Menu item updated",
  "extra38": "Unable to update menu item",
  "extra39": "Menu item removed",
  "extra40": "Unable to remove menu item",
  "extra41": "Edit Menu",
  "extra42": "Create Menu",
  "extra43": "Save",
  "extra44": "this item",
  "extra45": "Outlet link not ready",
  "extra46": "Copy outlet URL",
  "extra47": "Unable to load POS staff",
  "extra48": "Please try again.",
  "extra49": "Unable to load eligible staff",
  "extra50": "Unable to assign staff",
  "extra51": "Unable to save staff access",
  "extra52": "Unable to reset PIN",
  "extra53": "PIN copied",
  "extra54": "Share it securely with the staff member.",
  "extra55": "Enabled",
  "extra56": "Disabled",
  "extra57": "Club staff member",
  "extra59": "Never",
  "extra60": "Disable",
  "extra61": "Enable",
  "extra62": "Select product",
  "extra63": "Recipe ready",
  "extra64": "No recipe",
  "extra65": "Select stock item",
  "extra66": "Please try again shortly.",
  "extra67": "Unable to load outlets",
  "extra68": "Unable to load menus",
  "extra69": "Unable to load stock-tracked items",
  "extra70": "Inventory locations unavailable",
  "extra71": "Dining areas unavailable",
  "extra72": "Search failed",
  "extra76": "Outlet updated",
  "extra77": "Outlet created",
  "extra78": "Unable to save outlet",
  "extra79": "Menu updated",
  "extra80": "Menu created",
  "extra81": "Unable to save menu",
  "extra82": "Menu duplicated",
  "extra83": "Duplicate failed",
  "extra84": "Product name required",
  "extra85": "Sell price must be zero or higher",
  "extra86": "Product created",
  "extra87": "Unable to create product",
  "extra88": "Product updated",
  "extra89": "Unable to update product",
  "extra90": "Product deactivated",
  "extra91": "This product is currently used on a menu. Remove it from menus before deactivating, or try again after the menu is updated.",
  "extra92": "Unable to deactivate product",
  "extra93": "Select a product.",
  "extra94": "Add at least one recipe line.",
  "extra95": "Select a stock-tracked item.",
  "extra96": "Enter a quantity greater than zero.",
  "extra97": "Select a unit.",
  "extra98": "Duplicate ingredient/unit lines are not supported.",
  "extra100": "Recipe validation failed",
  "extra101": "Fix the highlighted recipe fields.",
  "extra102": "Recipe updated",
  "extra103": "Recipe saved",
  "extra104": "Unable to save recipe",
  "extra105": "No new items selected",
  "extra106": "Selected items are already on this menu.",
  "extra107": "Items added to menu",
  "extra108": "Unable to add selected items",
  "extra109": "Unable to update label",
  "extra110": "Unable to delete menu item",
  "extra111": "Unable to reorder",
  "extra112": "Unable to fetch OTP",
  "extra113": "Terminal secret regenerated",
  "extra114": "Unable to regenerate secret",
  "extra115": "Unable to load ePOS transactions.",
  "extra116": "Unable to load transaction detail.",
  "extra117": "This club",
  "extra118": "Untitled",
  "extra119": "Open outlet terminal",
  "extra121": "Not set",
  "extra122": "Not linked",
  "extra123": "Unassigned menu",
  "extra124": "Recipe",
  "extra125": "Linked stock",
  "extra126": "No recipe yet",
  "extra127": "ePOS product",
  "extra129": "Unnamed item",
  "extra130": "Product category",
  "extra131": "Tax code",
  "extra132": "Food",
  "extra133": "Drinks",
  "extra134": "Dessert",
  "extra135": "Kitchen",
  "extra136": "Other",
  "extra137": "Managed from Inventory",
  "extra138": "Consumes 1 stock unit",
  "extra139": "Sellable",
  "extra140": "Edit recipe lines",
  "extra141": "Create recipe",
  "extra142": "Update recipe",
  "extra143": "Save recipe",
  "extra144": "Outlet",
  "extra145": "Opened",
  "extra146": "Status",
  "extra147": "Subtotal",
  "extra148": "Tax",
  "extra149": "Total",
  "extra150": "Staff",
  "extra151": "Action",
  "extra152": "Guest",
  "extra153": "Sale",
  "extra154": "Time",
  "extra155": "Products sold",
  "extra156": "Qty",
  "extra157": "Gross",
  "extra158": "Net",
  "extra159": "Inventory",
  "extra160": "Accounting",
  "extra161": "POS Sale Detail",
  "extra162": "POS Order Detail",
  "extra163": "Operational sale summary with payments, fulfilment, and accounting status.",
  "extra164": "Operational order/check summary for staff and managers.",
  "extra165": "Member",
  "extra166": "Sale for",
  "extra167": "Member / guest",
  "extra168": "Item",
  "extra169": "Voided allocation",
  "extra170": "Allocated",
  "extra171": "Member charge",
  "extra172": "GL account",
  "extra173": "Stock item",
  "extra174": "Consumed",
  "extra175": "Edit product category",
  "extra176": "Edit tax code",
  "extra177": "Setup wizard validation failed",
  "extra178": "Setup created",
  "extra179": "Setup wizard failed",
  "extra180": "Table not found. Refresh tables and try again.",
  "extra181": "Sale not found for this occupied table. Refresh tables and try again.",
  "extra182": "This table already has an open sale. Refresh tables and open the existing sale.",
  "extra183": "Occupied table was missing a sale id and recovery failed. Refresh tables and try again.",
  "extra184": "POS session expired. Please unlock this terminal again.",
  "extra185": "This table is served by a shared dining area but this terminal was not authorised to access the sale.",
  "extra186": "POS session expired or unauthorized. Re-enter OTP and try again.",
  "extra187": "Unable to open table. Check connectivity and try again.",
  "extra188": "Payment failed. Retry or choose another method.",
  "extra189": "This member doesn't have account charges enabled.",
  "extra190": "Please select a member before charging an account.",
  "extra191": "Member could not be found.",
  "extra192": "Something went wrong. Please try again.",
  "extra193": "Multiple items match this barcode",
  "extra194": "Barcode not recognised",
  "extra195": "Select a table to begin.",
  "extra196": "Tap menu items to start a sale.",
  "extra197": "Sent to kitchen",
  "extra198": "Send to kitchen",
  "extra199": "Clear sale",
  "extra200": "Confirm send",
  "extra201": "POS Terminal",
  "extra202": "Log in",
  "extra203": "POS is offline. Check connectivity and try again.",
  "extra204": "Floor plan could not be loaded. Tiles are still available.",
  "extra206": "PIN is ambiguous, ask manager to reset one PIN.",
  "extra207": "PIN not recognised for this outlet.",
  "extra208": "Unable to log in. Check connectivity and try again.",
  "extra209": "Unable to start a new sale. Check connectivity and try again.",
  "extra210": "Unable to add item. Connection lost.",
  "extra211": "Sale not ready yet",
  "extra212": "Unable to remove item. Connection lost.",
  "extra213": "Unable to update quantity. Connection lost.",
  "extra214": "Unable to clear sale. Connection lost.",
  "extra215": "Recording cash payment…",
  "extra216": "Payment successful",
  "extra217": "Reader disconnected. Reconnect and retry.",
  "extra220": "No reader registered for this location in Stripe.",
  "extra221": "No simulated reader available. Enable Simulated Reader and retry.",
  "extra222": "Terminal location not configured for this outlet.",
  "extra224": "Stripe Terminal SDK is missing payment methods. Reload the terminal and retry.",
  "extra225": "Reader is busy. Disconnect the active session and retry.",
  "extra228": "Couldn’t connect to reader. Check the network or restart the reader.",
  "extra229": "POS revenue account is not configured for this item/club.",
  "extra230": "Card declined.",
  "extra231": "Couldn’t connect to Stripe Terminal. Check the network and try again.",
  "extra232": "Select a table before sending to kitchen.",
  "extra233": "Sending to kitchen…",
  "extra234": "Already sent to kitchen.",
  "extra235": "Sent to kitchen.",
  "extra237": "Preparing reader…",
  "extra238": "Connecting reader…",
  "extra239": "This outlet has no Stripe Terminal location configured.",
  "extra240": "Discovering simulated reader…",
  "extra241": "Discovering reader…",
  "extra242": "No simulated reader available.",
  "extra243": "Connecting to reader…",
  "extra244": "Stripe Terminal SDK missing payment methods.",
  "extra245": "Collecting payment method…",
  "extra246": "Payment intent missing.",
  "extra247": "Processing payment…",
  "extra248": "Payment processing failed.",
  "extra249": "Approved",
  "extra250": "Select a member to charge.",
  "extra251": "Charging member account…",
  "extra252": "Added to member account",
  "extra253": "Member account charge failed. Retry or choose another method.",
  "extra254": "Unable to apply member. Try again.",
  "extra255": "Sale not ready yet. Try again.",
  "extra256": "Member not found. Check the number and try again.",
  "extra257": "Unable to remove member. Try again.",
  "extra258": "Unable to unassign table. Connection lost.",
  "extra259": "Ready",
  "extra260": "No table selected",
  "extra261": "Tap to add · Hold for modifiers",
  "extra262": "Available",
  "extra263": "Use barcode/search from the terminal tools.",
  "extra264": "Coming soon",
  "extra265": "Account charge",
  "extra266": "Templates",
  "extra267": "Library",
  "extra268": "Properties",
  "extra269": "Premium touch-first POS screen template.",
  "extra270": "All outlets",
  "extra271": "Not assigned",
  "extra272": "This template is not currently assigned to any outlets.",
  "extra273": "Missing product",
  "extra274": "Product",
  "extra275": "Button",
  "extra276": "Create or select a draft template before using Privana Assist.",
  "extra277": "Privana Assist can only update draft templates. Duplicate this template to create an editable version.",
  "extra278": "Describe a layout; no live POS screen changes until you review and apply it.",
  "extra280": "Continue",
  "extra281": "Which type of outlet are you designing?",
  "extra282": "Looks right",
  "extra284": "Privana designed this layout",
  "extra285": "Updated",
  "extra286": "New",
  "extra287": "Applying atomically…",
  "extra288": "Use this layout",
  "extra289": "Proposal ready for review.",
  "extra290": "Privana Assist was cancelled or timed out. Your template is unchanged.",
  "extra291": "Privana Assist could not prepare a safe proposal. Your template is unchanged.",
  "extra292": "Privana Assist generation cancelled. Your template is unchanged.",
  "extra293": "The proposal could not be cancelled.",
  "extra294": "The proposal could not be cancelled before regeneration.",
  "extra295": "The proposal could not be cancelled before changing products.",
  "extra296": "Layout applied. The template remains a draft until you publish it.",
  "extra297": "The proposal could not be applied. No changes were made.",
  "extra307": "Assigned",
  "extra308": "Inherits global",
  "extra309": "Legacy fallback",
  "extra312": "No template selected",
  "extra313": "Create a page",
  "extra315": "No template",
  "extra316": "Enter one-time code from manager",
  "extra317": "Verifying code…",
  "extra318": "Terminal access required",
  "extra319": "Member attached",
  "extra320": "Looking up…",
  "extra321": "Apply",
  "extra331": "General",
  "extra332": "Dining zone",
  "extra334": "Table",
  "extra340": "Floor plan not set up yet. Use Dining Management to create one.",
  "extra345": "Dining floor plan",
  "search": "Search…",
  "outletTypes": {
    "bar": "Bar",
    "dining": "Dining",
    "pro_shop": "Pro Shop",
    "halfway_house": "Halfway House"
  },
  "setupModes": {
    "stock_only": "Stock only",
    "simple_product": "Simple product bought and sold as-is",
    "draft_beer": "Draft beer / measured drink",
    "food_recipe": "Recipe / food item"
  },
  "actions": {
    "open_tables": "Open tables",
    "search_products": "Search products",
    "member_lookup": "Membership lookup",
    "open_tabs": "Open tabs",
    "discounts": "Discounts",
    "refunds": "Refunds",
    "transfer_table": "Transfer table",
    "split_bill": "Split bill",
    "print_bill": "Print bill"
  },
  "dynamic": {
    "todays_specials": "Today's specials",
    "happy_hour": "Happy hour items",
    "top_sellers": "Top sellers",
    "recently_sold": "Recently sold",
    "low_stock": "Low stock"
  },
  "devices": {
    "tablet10": "10 inch tablet",
    "terminal15": "15 inch terminal",
    "desktop": "Desktop terminal",
    "landscapeTablet": "Landscape tablet"
  },
  "statuses": {
    "open": "Open",
    "pending": "Pending",
    "pending_payment": "Pending payment",
    "sent_to_kitchen": "Sent to kitchen",
    "unpaid": "Unpaid",
    "paid": "Paid",
    "completed": "Completed",
    "void": "Void",
    "voided": "Voided",
    "refunded": "Refunded",
    "partially_refunded": "Partially refunded",
    "cancelled": "Cancelled",
    "failed": "Failed",
    "processing": "Processing",
    "succeeded": "Succeeded",
    "active": "Active",
    "inactive": "Inactive",
    "draft": "Draft",
    "published": "Published",
    "archived": "Archived",
    "standard": "Standard",
    "enhanced": "Enhanced",
    "cash": "Cash",
    "card": "Card",
    "card_present": "Card present",
    "member_account": "Member account",
    "member_charge": "Member charge",
    "consumed": "Consumed",
    "settled": "Settled",
    "partially_paid": "Partially paid",
    "closed": "Closed",
    "posted": "Posted",
    "not_posted": "Not posted",
    "not_required": "Not required",
    "sale": "Sale",
    "refund": "Refund",
    "pos_sale": "POS sale",
    "pos_void": "POS void",
    "pos_refund": "POS refund",
    "warning": "Warning",
    "applied": "Applied",
    "deducted": "Deducted",
    "not_costed": "Not costed",
    "pending_cost": "Pending cost",
    "reversed": "Reversed",
    "partially_settled": "Partially settled",
    "authorized": "Authorized",
    "sent": "Sent",
    "partially_sent": "Partially sent",
    "build": "Build",
    "improve": "Improve",
    "partial": "Partial"
  },
  "units": {
    "each": "each",
    "ml": "ml",
    "L": "L",
    "g": "g",
    "kg": "kg",
    "bottle": "bottle",
    "case": "case",
    "keg": "keg",
    "barrel": "barrel",
    "packages": "packages",
    "package": "package",
    "stock": "stock"
  },
  "runtime": {
    "noItems": "No menu items configured.",
    "searchHelp": "Search all active products for this club and add directly to the current sale.",
    "searchPlaceholder": "Search drinks, food, retail…",
    "searchUnavailable": "Search unavailable. Try again.",
    "searching": "Searching…",
    "noMatches": "No matching products.",
    "startTyping": "Start typing to search products.",
    "search": "Search",
    "home": "Home",
    "folder": "Folder",
    "emptyPage": "This designed page has no buttons yet.",
    "emptyFolder": "This folder has no buttons yet.",
    "unavailable": "This function is not available yet.",
    "unavailableLabel": "{label}, coming soon, unavailable",
    "codeDigit": "Code digit {digit}"
  },
  "recipe": {
    "packaged": "{name} is stocked as {size} {packageUnit} {unit}; recipe usage can be entered in {units}.",
    "incompatible": "{name} uses {unit}; choose a compatible unit."
  },
  "messages": {
    "orderCheck": "Order/check",
    "tableMemberGuest": "Table/member/guest",
    "defaultMenu": " • Default menu: {name}",
    "default": "Default {name}",
    "assignedCount": "Assigned to {count} outlet(s)",
    "stocked": "Stocked as {size} {packageUnit} {unit}",
    "removeStaff": "Remove {name} from ePOS? Their core staff account will remain active.",
    "linkedOne": "This product is linked one-to-one with {name}.",
    "schema": "The ePOS product/recipe schema is still being migrated.",
    "genericError": "Unable to complete this action. Please try again.",
    "unassign": "Unassign table {name}",
    "clearing": "Clearing…",
    "sending": "Sending…",
    "checking": "Checking…",
    "added": "Added {name}",
    "kitchenNotified": "Sent to kitchen · {count} station(s) notified.",
    "kitchenFailed": "Unable to notify kitchen. Check connectivity and try again.",
    "table": "Table {name}",
    "seats": "{count} seats",
    "generating": "Generating…",
    "select": "Select {name}",
    "templateAssigned": "This template is currently assigned to {count} outlet assignment(s): {names}.",
    "thinkRetail": "I think you're designing a {name}.",
    "designedRetail": "Privana designed this screen for a {name}",
    "pageNumber": "Page {number}",
    "deletePage": "Delete {name}? {count} folder button(s) ({folders}) currently open this designed page. If you continue, those folders will fall back to their child-node auto layout.",
    "openPanel": "Open {name} panel",
    "showSummary": "Show {name} summary",
    "unlinked": "{name} not linked",
    "selectTable": "Select table {name}",
    "sku": "SKU {sku}",
    "taxRate": "Tax {rate}",
    "unitsOr": " or ",
    "recipeQty": " / Recipe {quantity} {unit}"
  },
  "tax": {
    "noCode": "No tax code",
    "loading": "Loading tax codes…",
    "select": "Select tax code",
    "unavailable": "Tax codes unavailable"
  },
  "retail": {
    "golf_pro_shop": "Golf Pro Shop",
    "main_bar": "Main Bar",
    "restaurant": "Restaurant",
    "halfway_house": "Halfway House",
    "coffee_shop": "Coffee Shop",
    "spa_retail": "Spa Retail",
    "golf_academy": "Golf Academy",
    "tennis_shop": "Tennis Shop",
    "padel_shop": "Padel Shop",
    "fitness_reception": "Fitness Reception",
    "marina_shop": "Marina Shop",
    "generic_retail": "Generic Retail",
    "other": "Other"
  },
  "priorities": {
    "Fast checkout": "Fast checkout",
    "Repeat purchases": "Repeat purchases",
    "Premium equipment browsing": "Premium equipment browsing",
    "Upselling accessories": "Upselling accessories",
    "Fast service": "Fast service",
    "Popular drinks": "Popular drinks",
    "Simple staff navigation": "Simple staff navigation",
    "Fast table ordering": "Fast table ordering",
    "Clear courses": "Clear courses",
    "Add-on visibility": "Add-on visibility",
    "Grab-and-go purchases": "Grab-and-go purchases",
    "Drink customisation": "Drink customisation",
    "Food add-ons": "Food add-ons",
    "Premium presentation": "Premium presentation",
    "Simple product discovery": "Simple product discovery",
    "Fast booking": "Fast booking",
    "Clear coaching options": "Clear coaching options",
    "Equipment browsing": "Equipment browsing",
    "Essential supplies": "Essential supplies",
    "Clear categories": "Clear categories"
  },
  "objectives": {
    "Fastest Checkout": "Fastest Checkout",
    "Increase Retail Sales": "Increase Retail Sales",
    "Premium Merchandising": "Premium Merchandising",
    "Self-Service Friendly": "Self-Service Friendly",
    "Fast Staff Training": "Fast Staff Training"
  },
  "metrics": {
    "Pages affected": "Pages affected",
    "New pages": "New pages",
    "Updated pages": "Updated pages",
    "New folders": "New folders",
    "Unique products": "Unique products",
    "Home shortcuts": "Home shortcuts",
    "Actions": "Actions",
    "Deletions": "Deletions"
  },
  "fragments": {
    "message0": "{v0} search",
    "message1": "Default {v0}",
    "message2": " • Default menu: {v0}",
    "message3": "Assigned to {v0} outlet{v1}",
    "message4": "SKU {v0}",
    "message5": "Tax {v0}",
    "message6": "This product is linked one-to-one with {v0}.",
    "message7": "Unassign table {v0}",
    "message8": "Added {v0}",
    "message9": "{v0}Table {v1}",
    "message10": "{v0} seats",
    "message11": "This template is currently assigned to {v0} outlet assignment{v1}: {v2}.",
    "message12": "Delete {v0}? {v1} folder button{v2} ({v3}) currently open this designed page. If you continue, those folders will fall back to their child-node auto layout.",
    "message13": "Open {v0} panel",
    "message14": "{v0}, coming soon, unavailable",
    "message15": "Show {v0} summary",
    "message16": "{v0} not linked",
    "message17": "Select table {v0}",
    "message18": "Table {v0}"
  },
  "nodeTypes": {
    "product": "Product",
    "folder": "Folder",
    "action": "Action",
    "dynamic": "Dynamic"
  }
};
